import type { ComputedRef, ShallowRef } from "vue";
import type { DataStateStatus } from "@pinia/colada";

export type StatusIcons = Partial<Record<DataStateStatus, string>>;

export function getStatusIcon(icons: StatusIcons, isLoading: ComputedRef<boolean>, status: ShallowRef<DataStateStatus>) {
  return computed(() => {
    if (isLoading.value) return "i-local-loading animate-spin";
    switch (status.value) {
      case "error":
        return icons.error || "i-lucide-triangle-alert";
      case "success":
        return icons.success || "i-local-check";
      default:
      case "pending":
        return icons.pending || "i-lucide-arrow-right";
    }
  });
}
